import styled from 'styled-components';

export const List = styled.div`
  grid-area: list;
  line-height: 30px;
  flex-direction: column;
  display: flex;
  max-width: 275px;
  & .button {
    margin: 1px 0px;
    width: 100%;
  }
`;
